import { render } from "./EnvioMagicLinksGrupo.vue?vue&type=template&id=2e536774&scoped=true"
import script from "./EnvioMagicLinksGrupo.vue?vue&type=script&lang=js"
export * from "./EnvioMagicLinksGrupo.vue?vue&type=script&lang=js"

import "./EnvioMagicLinksGrupo.vue?vue&type=style&index=0&id=2e536774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e536774"]])

export default __exports__